import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'report',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ReportContainer = require('./containers/ReportContainer').default
      const sunburstChartDataReducer = require('components/SunburstChart/reducers').default;
      const sunburstFilterReducer = require('components/SunburstChart/reducers').handleFilters;
      const timeSeriesChartDataReducer = require('components/TimeSeriesChart/reducers').default;

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'sunburstData', reducer: sunburstChartDataReducer });
      injectReducer(store, { key: 'sunburstFilter', reducer: sunburstFilterReducer });
      injectReducer(store, { key: 'chartData', reducer: timeSeriesChartDataReducer })

      /*  Return getComponent   */
      cb(null, ReportContainer)

    /* Webpack named bundle   */
    }, 'report')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Report/index.js